import Vue from 'vue'
import Router from 'vue-router'

const Home = () => import('@/components/Home')
const Loading = () => import('@/components/loading')
const customerStage = () => import('@/components/set-center/customer-stage')
const customerLabel = () => import('@/components/set-center/customer-label')
const customerLabelStatistics = () => import('@/components/set-center/customer-label-statistics')
const customerAttribute = () => import('@/components/set-center/customer-attribute')
const customerSource = () => import('@/components/set-center/customer-source')
const customerEvent = () => import('@/components/set-center/customer-event')
const customerTypes = () => import('@/components/set-center/customer-types')
// 设置产品管理
const setProductType = () => import('@/components/set-center/set-product-type')
const setProductAttr = () => import('@/components/set-center/set-product-attr')
// 资源订单管理
const orderManage = () => import('@/components/resources/order-manage')
const orderManageDetail = () => import('@/components/resources/order-manage-detail')
// 资源产品管理
const productManage = () => import('@/components/resources/product-manage')
const productManageAdd = () => import('@/components/resources/product-add')
// 云盘
const cloudDisk = () => import('@/components/resources/cloud-disk')
const cloudDiskDetail = () => import('@/components/resources/cloud-disk-detail')
const cloudDiskEmpty = () => import('@/components/resources/cloud-disk-empty')

const setAll = () => import('@/components/set-center/set-all')
const setSource = () => import('@/components/set-center/set-source')
const setEvent = () => import('@/components/set-center/set-event')
const customerManage = () => import('@/components/customer-manage/customer-manage')
const audiencesManage = () => import('@/components/customer-manage/audiences-manage')
const tagList = () => import('@/components/customer-manage/tag-list')
const audiencesGroupManage = () => import('@/components/customer-manage/audiences-group-manage')
const audiencesGroupManageAdd = () => import('@/components/customer-manage/audiences-group-manage-add')
const audiencesGroupManageAppend = () => import('@/components/customer-manage/audiences-group-manage-append')
const audGroupManageDetail = () => import('@/components/customer-manage/aud-group-manage-detail')
const customerDetail = () => import('@/components/customer-manage/customer-detail')
const groupManage = () => import('@/components/customer-manage/group-manage')
const importData = () => import('@/components/set-center/import-data')
const easyOrder = () => import('@/components/set-center/easy-order')
const importDataHistory = () => import('@/components/set-center/import-data-history')
const importDataResult = () => import('@/components/set-center/import-data-result')
const exportData = () => import('@/components/set-center/export-data')
const exportDataOrder = () => import('@/components/set-center/export-data-order')
const dataCenter = () => import('@/components/set-center/data-center')
const modelConsumer = () => import('@/components/customer-manage/model-consumer')
const modelBusiness = () => import('@/components/customer-manage/model-business')
// 首页更新日志详情
const updateLog = () => import('@/components/set-center/update-log')
const groupManageDetil = () => import('@/components/customer-manage/group-manage-detail')
const login = () => import('@/components/login')
const customerAnalysis = () => import('@/components/set-center/customer-analysis')
const wechatAnalysis = () => import('@/components/set-center/wechat-analysis')
const dataInoutNav = () => import('@/components/set-center/data-inout-nav')
const messageList = () => import('@/components/message-manage/message-list')
const signManage = () => import('@/components/message-manage/sign-manage')
const sendRecord = () => import('@/components/message-manage/send-record')
const autoProcess = () => import('@/components/message-manage/auto-process')
// 流程
const flowChart = () => import('@/components/process/flowChart')
const flowChart2 = () => import('@/components/process/flowChart2')
const falseModel = () => import('@/components/process/false-model')
const qrCode = () => import('@/components/weixin-manage/qr-code')
const qrcodeAdd = () => import('@/components/weixin-manage/qrcode-add')
const qrcodeEdit = () => import('@/components/weixin-manage/qrcode-edit')
// 会员管理
const memberList = () => import('@/components/member-manage/member-list')
const memberDetails = () => import('@/components/member-manage/member-details')
const memberInterestOrder = () => import('@/components/member-manage/member-interest-order')
const memberGradeSetting = () => import('@/components/member-manage/member-grade-setting')
const memberInterestSetting = () => import('@/components/member-manage/member-interest-setting')
const addMemberInterest = () => import('@/components/member-manage/add-member-interest')
const advertiseList = () => import('@/components/member-manage/advertise-list')
const noticeList = () => import('@/components/member-manage/notice-list')
const addNotice = () => import('@/components/member-manage/add-notice')
const editNotice = () => import('@/components/member-manage/edit-notice')
const productList = () => import('@/components/member-manage/product-list')
const orderList = () => import('@/components/member-manage/order-list')
const integralSetting = () => import('@/components/member-manage/integral-setting')
// 注册有礼
const registerPolite = () => import('@/components/member-manage/register-polite')
const addRegisterPolite = () => import('@/components/member-manage/add-register-polite')
const editRegisterPolite = () => import('@/components/member-manage/edit-register-polite')
// 签到管理
const signInManage = () => import('@/components/member-manage/signIn-manage')
// 微信管理
const openPlatform = () => import('@/components/weixin-manage/open-platform')
const publicNumber = () => import('@/components/weixin-manage/public-number')
const bindPublicNumber = () => import('@/components/weixin-manage/bind-public-number')
const ReplyKeyWord = () => import('@/components/weixin-manage/reply-keyWord')
const ReplyKeyWordAdd = () => import('@/components/weixin-manage/reply-keyWord-add')
const ReplyFollow = () => import('@/components/weixin-manage/reply-follow')
const ReplyDefault = () => import('@/components/weixin-manage/reply-default')
const customMenu = () => import('@/components/weixin-manage/custom-menu')
const customMenuAdd = () => import('@/components/weixin-manage/custom-menu-add')
const artificialService = () => import('@/components/weixin-manage/artificial-service')
const artificialServiceAdd = () => import('@/components/weixin-manage/artificial-service-add')
const wxPayment = () => import('@/components/weixin-manage/wx-payment')
const wxPaymentAdd = () => import('@/components/weixin-manage/wx-payment-add')
const wxPaymentEdit = () => import('@/components/weixin-manage/wx-payment-edit')
const templateMessage = () => import('@/components/weixin-manage/template-message')
const templateMessageAdd = () => import('@/components/weixin-manage/template-message-add')
const weChatSendGroup = () => import('@/components/weixin-manage/wechat-send-group')
// 微信公众号管理
const appletManage = () => import('@/components/applet/manage')
// 活动管理
const activityList = () => import('@/components/activity-manage/activity-list')
const addActivity = () => import('@/components/activity-manage/add-activity')
const activityDetails = () => import('@/components/activity-manage/activity-details')
const editActivity = () => import('@/components/activity-manage/edit-activity')
const activityStatistics = () => import('@/components/activity-manage/activity-statistics')
const microPage = () => import('@/components/activity-manage/micro-page')
const microPageAdd = () => import('@/components/activity-manage/micro-page-add')
const microPageEdit = () => import('@/components/activity-manage/micro-page-edit')
const microPageLook = () => import('@/components/activity-manage/micro-page-look')
const microPageData = () => import('@/components/activity-manage/micro-page-data')
const snManage = () => import('@/components/activity-manage/sn-manage')
const cheatManage = () => import('@/components/activity-manage/cheat-manage')
const editAdvertise = () => import('@/components/member-manage/edit-advertise')
const addAdvertise = () => import('@/components/member-manage/add-advertise')
const productDetails = () => import('@/components/member-manage/product-details')
const editProduct = () => import('@/components/member-manage/edit-product')
const addProduct = () => import('@/components/member-manage/add-product')
const editMemberInterest = () => import('@/components/member-manage/edit-member-interest')
// 景芝拜年活动
const newYearActivity = () => import('@/components/treasure-box/new-year-activity')
const addNewYearActivity = () => import('@/components/treasure-box/add-new-year-activity')
const editNewYearActivity = () => import('@/components/treasure-box/edit-new-year-activity')
const lookNewYearActivity = () => import('@/components/treasure-box/look-new-year-activity')
const newYearActivityStatistics = () => import('@/components/treasure-box/new-year-activity-statistics')
// 景芝猜灯谜活动
const guessRiddlesActivity = () => import('@/components/guess-riddles/activity')
const addGuessRiddlesActivity = () => import('@/components/guess-riddles/add-activity')
const editGuessRiddlesActivity = () => import('@/components/guess-riddles/edit-activity')
const lookGuessRiddlesActivity = () => import('@/components/guess-riddles/look-activity')
const guessRiddlesActivityStatistics = () => import('@/components/guess-riddles/activity-statistics')
const guessRiddlesTopic = () => import('@/components/guess-riddles/topic')
// 景芝龙抬头活动
const dragonActivity = () => import('@/components/dragon/dragon-activity')
const addDragonActivity = () => import('@/components/dragon/add-dragon-activity')
const editDragonActivity = () => import('@/components/dragon/edit-dragon-activity')
const lookDragonActivity = () => import('@/components/dragon/look-dragon-activity')
const dragonActivityStatistics = () => import('@/components/dragon/dragon-activity-statistics')
// 营销活动
const activity = () => import('@/components/activity/activity')
const activityWechat = () => import('@/components/activity/activity2')
const addActivitys = () => import('@/components/activity/add-activity')
const editActivitys = () => import('@/components/activity/edit-activity')
const lookActivitys = () => import('@/components/activity/look-activity')
const activitysStatistics = () => import('@/components/activity/activity-statistics')
const activitysQuestion = () => import('@/components/activity/question')
// 营销活动-- 活动首页
const activeHome = () => import('@/components/activity/activeHome')
// 券管理
const coupons = () => import('@/components/coupons/coupon')
const addCoupons = () => import('@/components/coupons/add-coupon')
const editCoupons = () => import('@/components/coupons/edit-coupon')
const couponsStatistics = () => import('@/components/coupons/coupon-statistics')
const couponsDetail = () => import('@/components/coupons/detail-coupon')
const couponsApprove = () => import('@/components/coupons/coupon-approve')
// 权限管理
const menuList = () => import('@/components/administrative/system/menu/list')
const menuAdd = () => import('@/components/administrative/system/menu/add')
const menuEdit = () => import('@/components/administrative/system/menu/edit')
const configAdd = () => import('@/components/administrative/system/config/add')
const ruleList = () => import('@/components/administrative/system/rule/list')
const ruleAdd = () => import('@/components/administrative/system/rule/add')
const ruleEdit = () => import('@/components/administrative/system/rule/edit')
// const structuresList = () => import('@/components/administrative/structures/structures/list')
const structuresList = () => import('@/components/administrative/structures/structures/newList')
const structuresAdd = () => import('@/components/administrative/structures/structures/add')
const structuresEdit = () => import('@/components/administrative/structures/structures/edit')
const groupsList = () => import('@/components/administrative/structures/groups/list')
const groupsAdd = () => import('@/components/administrative/structures/groups/add')
const groupsEdit = () => import('@/components/administrative/structures/groups/edit')
const positionList = () => import('@/components/administrative/structures/position/list')
const positionAdd = () => import('@/components/administrative/structures/position/add')
const positionRuleSet = () => import('@/components/administrative/structures/position/rule-set')
const positionRuleSetNew = () => import('@/components/administrative/structures/position/rule-setNew') // 权限设置，20200817新增
const positionEdit = () => import('@/components/administrative/structures/position/edit')
const userList = () => import('@/components/administrative/personnel/users/list')
const userAdd = () => import('@/components/administrative/personnel/users/add')
const userEdit = () => import('@/components/administrative/personnel/users/edit')
const businessAreaList = () => import('@/components/administrative/businessArea/list')
const businessAreaAddEdit = () => import('@/components/administrative/businessArea/addEdit')
// 线下活动
const activityCode = () => import('@/components/activity-manage/activity-code')
const activityCodeAdd = () => import('@/components/activity-manage/activity-code-add')
const salesmanList = () => import('@/components/offline-acivity/salesman-list')
const fieldManage = () => import('@/components/offline-acivity/field-manage')
const fieldTotal = () => import('@/components/offline-acivity/field-total')
const activityCountList = () => import('@/components/offline-acivity/activity-count-list')
const activityCountDetails = () => import('@/components/offline-acivity/activity-count-details')
const addOfflineAcivity = () => import('@/components/offline-acivity/add-offline-activity')
const editOfflineAcivity = () => import('@/components/offline-acivity/edit-offline-activity')
const offlineActivityList = () => import('@/components/offline-acivity/offline-activity-list')
const offlineActivitySet = () => import('@/components/offline-acivity/offline-activity-set')
const offlineActivityStatistics = () => import('@/components/offline-acivity/activity-statistics')
const participantsNumber = () => import('@/components/offline-acivity/participants-number')
const activityStatisticsList = () => import('@/components/offline-acivity/activity-statistics-list')
//卡券管理
const cardTicketModule = () => import('@/components/card-ticket/card-ticket-module')
//卡券发放明细
const cardTicketGrantDetails = () => import('@/components/card-ticket/card-ticket-grantDetails')
//卡券核销明细
const cardTicketHxoff = () => import('@/components/card-ticket/card-ticket-hxoff')
//新建卡券模板
const cardTicketNew = () => import('@/components/card-ticket/card-ticket-new')
//编辑卡券模板
const cardTicketEdit = () => import('@/components/card-ticket/card-ticket-edit')
//查看卡券模板
const cardTicketSee = () => import('@/components/card-ticket/card-ticket-see')
// 卡券核销设置
const writeOffSetUp = () => import('@/components/card-ticket/writeoff-setup')

// 灵感
const inspirationNotFinish = () => import('@/components/inspiration/inspiration-not-finish')
// 分析
const analyseNotFinish = () => import('@/components/analyse/analyse-not-finish')
const customerAnalyse = () => import('@/components/analyse/customer-analyse')
const behaviorAnalyse = () => import('@/components/analyse/behavior-analyse')
const funnelAnalyse = () => import('@/components/analyse/funnel-analyse')
const orderAnalyse = () => import('@/components/analyse/order-analyse')
const repurchaseAnalyse = () => import('@/components/analyse/repurchase-analyse')
const rfmAnalyse = () => import('@/components/analyse/rfm-analyse')
const singleChart = () => import('@/components/analyse/single-chart')
const boardDetails = () => import('@/components/analyse/board-details')
const boardList = () => import('@/components/analyse/board-list')
const boardStatistics = () => import('@/components/analyse/board-statistics1')
const addSingleChart = () => import('@/components/analyse/add-single-chart')

//云众-积分管理
const yzIntegralSet = () => import('@/components/applet/yzintegralset')
const yzGrade = () => import('@/components/applet/yzgrade')
const yzIntegralSetAdd = () => import('@/components/applet/yzintegralset_add')
const yzIntegralSetEdit = () => import('@/components/applet/yzintegralset_edit')
// 布奖
const prizeList = () => import('@/components/prize/prize-list')
const createPrize = () => import('@/components/prize/create-prize')
const editPrize = () => import('@/components/prize/edit-prize')
const templatePrize = () => import('@/components/prize/template-prize')
const prizeActivity = () => import('@/components/prize/prize-activity')
const prizeStatistics = () => import('@/components/prize/prize-statistics')
const setPrizeActivity = () => import('@/components/prize/set-prize-activity')
const editPrizeActivity = () => import('@/components/prize/edit-prize-activity')
const myTemplatePrize = () => import('@/components/prize/my-template-prize')
const templateDetails = () => import('@/components/prize/template-details')
//云销
const yxwelcome = () => import('@/components/yunxiao/yxwelcome')
const yxqa = () => import('@/components/yunxiao/yxqa')
const yxdealer = () => import('@/components/yunxiao/yxdealer')
const yxdealersub = () => import('@/components/yunxiao/yxdealersub')
const yxgroup = () => import('@/components/yunxiao/yxgroups/list')
const yxrules = () => import('@/components/yunxiao/yxgroups/rules')
const yxaccount = () => import('@/components/yunxiao/yxaccount')
const yxaccount_tx = () => import('@/components/yunxiao/yxaccount_tx')
const yxbank = () => import('@/components/yunxiao/yxbank')
const yxmarketing = () => import('@/components/yunxiao/yxmarketing')
const yxmarketingAdd = () => import('@/components/yunxiao/yxmarketing_add')
const yxmarketingEdit = () => import('@/components/yunxiao/yxmarketing_edit')
const yxoperatelog = () => import('@/components/yunxiao/yxoperatelog')

// 活动视频管理
const activityVideoManager = () => import('@/components/video-manage/activityVideoManager')
const videoListManager = () => import('@/components/video-manage/videoListManager')

Vue.use(Router)
const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    { path: '/', component: Loading },
    {
      path: '/home',
      name: 'Home',
      component: Home,
      children: [
        {
          path: 'order-manage',
          component: orderManage,
          name: 'orderManage',
          meta: {
            routeArr: [
              { name: '订单管理', Rpath: '/home/order-manage' },
              { name: '订单管理', Rpath: '/home/order-manage' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'order-manage-detail',
          component: orderManageDetail,
          name: 'orderManageDetail',
          meta: {
            routeArr: [
              { name: '订单管理', Rpath: '/home/order-manage-detail' },
              { name: '订单管理', Rpath: '/home/order-manage-detail' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'activity-code',
          component: activityCode,
          name: 'activityCode',
          meta: {
            routeArr: [
              { name: '活码管理', Rpath: '/home/activity-code' },
              { name: '活码管理', Rpath: '/home/activity-code' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'activity-code-add',
          component: activityCodeAdd,
          name: 'activityCodeAdd',
          meta: {
            routeArr: [
              { name: '活码管理', Rpath: '/home/activity-code' },
              { name: '活码管理', Rpath: '/home/activity-code-add' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'product-manage',
          component: productManage,
          name: 'productManage',
          meta: {
            routeArr: [
              { name: '产品管理', Rpath: '/home/product-manage' },
              { name: '产品管理', Rpath: '/home/product-manage' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'product-add',
          component: productManageAdd,
          name: ' productManageAdd',
          meta: {
            routeArr: [
              { name: '产品管理', Rpath: '/home/product-add' },
              { name: '产品管理', Rpath: '/home/product-add' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'cloud-disk',
          component: cloudDisk,
          name: 'cloudDisk',
          meta: {
            routeArr: [
              { name: '云盘', Rpath: '/home/cloud-disk' },
              { name: '文件', Rpath: '/home/cloud-disk' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'cloud-disk-detail',
          component: cloudDiskDetail,
          name: 'cloudDiskDetail',
          meta: {
            routeArr: [
              { name: '云盘', Rpath: '/home/cloud-disk' },
              { name: '文件', Rpath: '/home/cloud-disk-detail' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'cloud-disk-empty',
          component: cloudDiskEmpty,
          name: 'cloudDiskEmpty',
          meta: {
            routeArr: [
              { name: '云盘', Rpath: '/home/cloud-disk' },
              { name: '文件', Rpath: '/home/cloud-disk-empty' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'customer-source',
          component: customerSource,
          name: 'customerSource',
          meta: {
            routeArr: [
              { name: '客户画像', Rpath: '/home/customer-source' },
              { name: '客户来源', Rpath: '/home/customer-source' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'customer-event',
          component: customerEvent,
          name: 'customerEvent',
          meta: {
            routeArr: [
              { name: '客户画像', Rpath: '/home/customer-event' },
              { name: '客户事件', Rpath: '/home/customer-event' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'customer-stage',
          component: customerStage,
          name: 'customerStage',
          meta: {
            routeArr: [
              { name: '客户画像', Rpath: '/home/customer-stage' },
              { name: '客户等级', Rpath: '/home/customer-stage' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'customer-types',
          component: customerTypes,
          name: 'customerTypes',
          meta: {
            routeArr: [
              { name: '客户画像', Rpath: '/home/customer-types' },
              { name: '受众类型', Rpath: '/home/customer-types' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'set-product-type',
          component: setProductType,
          name: 'setProductType',
          meta: {
            routeArr: [
              { name: '产品配置', Rpath: '/home/set-product-type' },
              { name: '产品类型', Rpath: '/home/set-product-type' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'set-product-attr',
          component: setProductAttr,
          name: 'setProductList',
          meta: {
            routeArr: [
              { name: '产品配置', Rpath: '/home/set-product-attr' },
              { name: '产品模型', Rpath: '/home/set-product-attr' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'set-all',
          component: setAll,
          name: 'setAll',
          meta: {
            routeArr: [
              { name: '客户画像', Rpath: '/home/set-all' },
              { name: '配置属性/等级', Rpath: '/home/set-all' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'set-source',
          component: setSource,
          name: 'setSource',
          meta: {
            routeArr: [
              { name: '客户画像', Rpath: '/home/set-source' },
              { name: '受众来源', Rpath: '/home/set-source' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'set-event',
          component: setEvent,
          name: 'setEvent',
          meta: {
            routeArr: [
              { name: '客户画像', Rpath: '/home/set-event' },
              { name: '受众事件', Rpath: '/home/set-event' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'customer-label',
          component: customerLabel,
          name: 'customerLabel',
          meta: {
            routeArr: [
              { name: '客户画像', Rpath: '/home/customer-source' },
              { name: '客户标签', Rpath: '/home/customer-label' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'customer-label-statistics',
          component: customerLabelStatistics,
          name: 'customerLabelStatistics',
          meta: {
            routeArr: [
              { name: '客户标签', Rpath: '/home/customer-label' },
              { name: '标签统计', Rpath: '/home/customer-label-statistics' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'customer-attribute',
          component: customerAttribute,
          name: 'customerAttribute',
          meta: {
            routeArr: [
              { name: '客户画像', Rpath: '/home/customer-attribute' },
              { name: '客户属性', Rpath: '/home/customer-attribute' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'customer-manage',
          component: customerManage,
          name: 'customerManage',
          meta: {
            routeArr: [
              { name: '客户管理', Rpath: '/home/customer-manage' },
              { name: '客户管理', Rpath: '/home/customer-manage' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
            // keepAlive: true
          }
        },
        {
          path: 'audiences-manage/:id',
          component: audiencesManage,
          name: 'audiencesManage',
          meta: {
            routeArr: [
              { name: '受众管理', Rpath: '/home/audiences-manage' },
              { name: '受众管理', Rpath: '/home/audiences-manage' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
            // keepAlive: true
          }
        },
        {
          path: 'tag-list/:id',
          component: tagList,
          name: 'tagList',
          meta: {
            routeArr: [
              { name: '受众管理', Rpath: '/home/tag-list' },
              { name: '标签管理', Rpath: '/home/tag-list' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
            // keepAlive: true
          }
        },
        {
          path: 'audiences-group-manage/:id',
          component: audiencesGroupManage,
          name: 'audiencesGroupManage',
          meta: {
            routeArr: [
              { name: '受众管理', Rpath: '/home/audiences-group-manage' },
              { name: '受众管理', Rpath: '/home/audiences-group-manage' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
            // keepAlive: true
          }
        },
        {
          path: 'audiences-group-manage-add/:id',
          component: audiencesGroupManageAdd,
          name: 'audiencesGroupManageAdd',
          meta: {
            routeArr: [
              { name: '群组管理', Rpath: '/home/audiences-group-manage' },
              { name: '受众管理', Rpath: '/home/audiences-group-manage-add' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
            // keepAlive: true
          }
        },
        {
          path: 'audiences-group-manage-append/:id',
          component: audiencesGroupManageAppend,
          name: 'audiencesGroupManageAppend',
          meta: {
            routeArr: [
              { name: '群组管理', Rpath: '/home/audiences-group-manage' },
              { name: '受众管理', Rpath: '/home/audiences-group-manage-append' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
            // keepAlive: true
          }
        },
        {
          path: 'aud-group-manage-detail/:id',
          component: audGroupManageDetail,
          name: 'audGroupManageDetail',
          meta: {
            routeArr: [
              { name: '受众管理', Rpath: '/home/audiences-group-manage' },
              { name: '受众管理', Rpath: '/home/aud-group-manage-detail' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
            // keepAlive: true
          }
        },
        {
          path: 'customer-detail',
          component: customerDetail,
          name: 'customerDetail',
          meta: {
            routeArr: [
              { name: '客户管理', Rpath: '/home/customer-manage' },
              { name: '客户详情', Rpath: '/home/customer-detail' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'group-manage',
          component: groupManage,
          name: 'groupManage',
          meta: {
            routeArr: [
              { name: '客户管理', Rpath: '/home/group-manage' },
              { name: '群组管理', Rpath: '/home/group-manage' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'data-inout-nav',
          component: dataInoutNav,
          name: 'dataInoutNav',
          meta: {
            routeArr: [
              { name: '导出', Rpath: '/home/data-inout-nav' },
              { name: '导出', Rpath: '/home/data-inout-nav' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'import-data',
          component: importData,
          name: 'importData',
          meta: {
            routeArr: [
              { name: '数据导入导出', Rpath: '/home/data-inout-nav' },
              { name: '数据导入', Rpath: '/home/import-data' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'easy-order',
          component: easyOrder,
          name: 'easyOrder',
          meta: {
            routeArr: [
              { name: '数据导入导出', Rpath: '/home/data-inout-nav' },
              { name: '数据导入', Rpath: '/home/easy-order' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'import-data-history',
          component: importDataHistory,
          name: 'importDataHistory',
          meta: {
            routeArr: [
              { name: '数据导入导出', Rpath: '/home/data-inout-nav' },
              { name: '导入历史', Rpath: '/home/import-data-history' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'import-data-result',
          component: importDataResult,
          name: 'importDataResult',
          meta: {
            routeArr: [
              { name: '导入客户属性', Rpath: '/home/import-data-result' },
              { name: '导入客户属性', Rpath: '/home/import-data-result' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'export-data',
          component: exportData,
          name: 'exportData',
          meta: {
            routeArr: [
              { name: '导出', Rpath: '/home/data-inout-nav' },
              { name: '受众导出', Rpath: '/home/export-data' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'export-data-order',
          component: exportDataOrder,
          name: 'exportDataOrder',
          meta: {
            routeArr: [
              { name: '导出', Rpath: '/home/data-inout-nav' },
              { name: '数据导出', Rpath: '/home/export-data-order' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'group-manage-detail',
          component: groupManageDetil,
          name: 'groupManageDetil',
          meta: {
            routeArr: [
              { name: '群组管理', Rpath: '/home/group-manage' },
              { name: '群组管理详情', Rpath: '/home/group-manage-detail' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'data-center',
          component: dataCenter,
          name: 'dataCenter',
          meta: {
            routeArr: [
              { name: '系统首页', Rpath: '/home/data-center' }
              // { name: '', Rpath: '/home/data-center' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'update-log',
          component: updateLog,
          name: 'updateLog',
          meta: {
            routeArr: [
              { name: '首页', Rpath: '/home/data-center' },
              { name: '产品更新日志', Rpath: '/home/update-log' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'customer-analysis',
          component: customerAnalysis,
          name: 'customerAnalysis',
          meta: {
            routeArr: [
              { name: '客户分析', Rpath: '/home/customer-analysis' },
              { name: '客户分析', Rpath: '/home/customer-analysis' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'wechat-analysis',
          component: wechatAnalysis,
          name: 'wechatAnalysis',
          meta: {
            routeArr: [
              { name: '微信分析', Rpath: '/home/wechat-analysis' },
              { name: '微信分析', Rpath: '/home/wechat-analysis' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'message-list',
          component: messageList,
          name: 'messageList',
          meta: {
            routeArr: [
              { name: '短信管理', Rpath: '/home/message-list' },
              { name: '短信列表', Rpath: '/home/message-list' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'sign-manage',
          component: signManage,
          name: 'signManage',
          meta: {
            routeArr: [
              { name: '短信管理', Rpath: '/home/sign-manage' },
              { name: '签名管理', Rpath: '/home/sign-manage' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'send-record',
          component: sendRecord,
          name: 'sendRecord',
          meta: {
            routeArr: [
              { name: '短信管理', Rpath: '/home/send-record' },
              { name: '发送记录', Rpath: '/home/send-record' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'qr-code',
          component: qrCode,
          name: 'qrCode',
          meta: {
            routeArr: [
              { name: '微信管理', Rpath: '/home/qr-code' },
              { name: '公众号二维码', Rpath: '/home/qr-code' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'wechat-send-group',
          component: weChatSendGroup,
          name: 'weChatSendGroup',
          meta: {
            routeArr: [
              { name: '微信管理', Rpath: '/home/wechat-send-group' },
              { name: '微信群发', Rpath: '/home/wechat-send-group' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'qrcode-add',
          component: qrcodeAdd,
          name: 'qrcodeAdd',
          meta: {
            routeArr: [
              { name: '微信管理', Rpath: '/home/qr-code' },
              { name: '添加二维码', Rpath: '/home/qrcode-add' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'qrcode-edit',
          component: qrcodeEdit,
          name: 'qrcodeEdit',
          meta: {
            routeArr: [
              { name: '微信管理', Rpath: '/home/qr-code' },
              { name: '编辑二维码', Rpath: '/home/qrcode-edit' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'auto-process',
          component: autoProcess,
          name: 'autoProcess',
          meta: {
            routeArr: [
              { name: '场景管理', Rpath: '/home/auto-process' },
              { name: '自动化流程', Rpath: '/home/auto-process' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'flow-chart',
          component: flowChart,
          name: 'flowChart',
          meta: {
            routeArr: [
              { name: '自动流程', Rpath: '/home/auto-process' },
              { name: '流程', Rpath: '/home/flow-chart' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'flow-chart2',
          component: flowChart2,
          name: 'flowChart2',
          meta: {
            routeArr: [
              { name: '流程', Rpath: '/home/flow-chart' },
              { name: '流程', Rpath: '/home/flow-chart' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'false-model',
          component: falseModel,
          name: 'falseModel',
          meta: {
            routeArr: [
              { name: '流程', Rpath: '/home/false-model' },
              { name: '模态框', Rpath: '/home/false-model' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'member-list',
          component: memberList,
          name: 'memberList',
          meta: {
            routeArr: [
              { name: '会员管理', Rpath: '/home/member-list' },
              { name: '会员列表', Rpath: '/home/member-list' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'signIn-manage',
          component: signInManage,
          name: 'signInManage',
          meta: {
            routeArr: [
              { name: '会员互动', Rpath: '/home/signIn-manage' },
              { name: '签到管理', Rpath: '/home/signIn-manage' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'register-polite',
          component: registerPolite,
          name: 'registerPolite',
          meta: {
            routeArr: [
              { name: '会员互动', Rpath: '/home/register-polite' },
              { name: '注册有礼', Rpath: '/home/register-polite' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'add-register-polite',
          component: addRegisterPolite,
          name: 'addRegisterPolite',
          meta: {
            routeArr: [
              { name: '注册有礼', Rpath: '/home/register-polite' },
              { name: '添加活动', Rpath: '/home/add-register-polite' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'edit-register-polite',
          component: editRegisterPolite,
          name: 'editRegisterPolite',
          meta: {
            routeArr: [
              { name: '注册有礼', Rpath: '/home/register-polite' },
              { name: '编辑活动', Rpath: '/home/edit-register-polite' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'member-details',
          component: memberDetails,
          name: 'memberDetails',
          meta: {
            routeArr: [
              { name: '会员列表', Rpath: '/home/member-list' },
              { name: '会员详情', Rpath: '/home/member-details' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'member-interest-order',
          component: memberInterestOrder,
          name: 'memberInterestOrder',
          meta: {
            routeArr: [
              { name: '会员权益订单', Rpath: '/home/member-interest-order' },
              { name: '会员权益订单', Rpath: '/home/member-interest-order' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'member-grade-setting',
          component: memberGradeSetting,
          name: 'memberGradeSetting',
          meta: {
            routeArr: [
              { name: '会员管理', Rpath: '/home/member-list' },
              { name: '等级设置', Rpath: '/home/member-grade-setting' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'member-interest-setting',
          component: memberInterestSetting,
          name: 'memberInterestSetting',
          meta: {
            routeArr: [
              { name: '会员管理', Rpath: '/home/member-list' },
              { name: '权益设置', Rpath: '/home/member-interest-setting' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'add-member-interest',
          component: addMemberInterest,
          name: 'addMemberInterest',
          meta: {
            routeArr: [
              { name: '会员权益设置', Rpath: '/home/member-interest-setting' },
              { name: '添加会员权益', Rpath: '/home/add-member-interest' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'notice-list',
          component: noticeList,
          name: 'noticeList',
          meta: {
            routeArr: [
              { name: '会员互动', Rpath: '/home/notice-list' },
              { name: '公告列表', Rpath: '/home/notice-list' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'add-notice',
          component: addNotice,
          name: 'addNotice',
          meta: {
            routeArr: [
              { name: '公告列表', Rpath: '/home/notice-list' },
              { name: '添加公告', Rpath: '/home/add-notice' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'edit-notice',
          component: editNotice,
          name: 'editNotice',
          meta: {
            routeArr: [
              { name: '公告列表', Rpath: '/home/notice-list' },
              { name: '编辑公告', Rpath: '/home/edit-notice' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'product-list',
          component: productList,
          name: 'productList',
          meta: {
            routeArr: [
              { name: '积分商城', Rpath: '/home/product-list' },
              { name: '商品列表', Rpath: '/home/product-list' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'activity-list',
          component: activityList,
          name: 'activityList',
          meta: {
            routeArr: [
              { name: '活动管理', Rpath: '/home/activity-list' },
              { name: '大转盘', Rpath: '/home/activity-list' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'new-year-activity',
          component: newYearActivity,
          name: 'newYearActivity',
          meta: {
            routeArr: [
              { name: '活动管理', Rpath: '/home/new-year-activity' },
              { name: '拜年活动', Rpath: '/home/new-year-activity' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'add-new-year-activity',
          component: addNewYearActivity,
          name: 'addNewYearActivity',
          meta: {
            routeArr: [
              { name: '活动管理', Rpath: '/home/new-year-activity' },
              { name: '添加拜年活动', Rpath: '/home/add-new-year-activity' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'edit-new-year-activity',
          component: editNewYearActivity,
          name: 'editNewYearActivity',
          meta: {
            routeArr: [
              { name: '活动管理', Rpath: '/home/new-year-activity' },
              { name: '编辑拜年活动', Rpath: '/home/edit-new-year-activity' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'look-new-year-activity',
          component: lookNewYearActivity,
          name: 'lookNewYearActivity',
          meta: {
            routeArr: [
              { name: '活动管理', Rpath: '/home/new-year-activity' },
              { name: '查看拜年活动', Rpath: '/home/look-new-year-activity' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'new-year-activity-statistics',
          component: newYearActivityStatistics,
          name: 'newYearActivityStatistics',
          meta: {
            routeArr: [
              { name: '活动管理', Rpath: '/home/new-year-activity' },
              { name: '拜年活动统计', Rpath: '/home/new-year-activity-statistics' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'dragon-activity',
          component: dragonActivity,
          name: 'dragonActivity',
          meta: {
            routeArr: [
              { name: '活动管理', Rpath: '/home/dragon-activity' },
              { name: '龙抬头活动', Rpath: '/home/dragon-activity' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'add-dragon-activity',
          component: addDragonActivity,
          name: 'addDragonActivity',
          meta: {
            routeArr: [
              { name: '活动管理', Rpath: '/home/dragon-activity' },
              { name: '添加龙抬头活动', Rpath: '/home/add-dragon-activity' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'edit-dragon-activity',
          component: editDragonActivity,
          name: 'editDragonActivity',
          meta: {
            routeArr: [
              { name: '活动管理', Rpath: '/home/dragon-activity' },
              { name: '编辑龙抬头活动', Rpath: '/home/edit-dragon-activity' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'look-dragon-activity',
          component: lookDragonActivity,
          name: 'lookDragonActivity',
          meta: {
            routeArr: [
              { name: '活动管理', Rpath: '/home/dragon-activity' },
              { name: '查看龙抬头活动', Rpath: '/home/look-dragon-activity' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'dragon-activity-statistics',
          component: dragonActivityStatistics,
          name: 'dragonActivityStatistics',
          meta: {
            routeArr: [
              { name: '活动管理', Rpath: '/home/dragon-activity' },
              { name: '龙抬头活动统计', Rpath: '/home/dragon-activity-statistics' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'activity',
          component: activity,
          name: 'activity',
          meta: {
            routeArr: [
              { name: '活动管理', Rpath: '/home/activity' },
              { name: '布奖活动管理', Rpath: '/home/activity' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'activityWechat',
          component: activityWechat,
          name: 'activityWechat',
          meta: {
            routeArr: [
              { name: '活动管理', Rpath: '/home/activityWechat?t=2' },
              { name: '微信活动管理', Rpath: '/home/activityWechat?t=2' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'activeHome',
          component: activeHome,
          name: 'activeHome',
          meta: {
            routeArr: [
              { name: '活动管理', Rpath: '/home/activeHome' },
              { name: '创建活动', Rpath: '/home/activeHome' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'coupons',
          component: coupons,
          name: 'coupons',
          meta: {
            routeArr: [
              { name: '活动管理', Rpath: '/home/coupons' },
              { name: '券管理', Rpath: '/home/coupons' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'add-coupons',
          component: addCoupons,
          name: 'addCoupons',
          meta: {
            routeArr: [
              { name: '券管理', Rpath: '/home/coupons' },
              { name: '添加券', Rpath: '/home/add-coupons' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'edit-coupons',
          component: editCoupons,
          name: 'editCoupons',
          meta: {
            routeArr: [
              { name: '券管理', Rpath: '/home/coupons' },
              { name: '编辑券', Rpath: '/home/edit-coupons' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'coupons-statistics',
          component: couponsStatistics,
          name: 'couponsStatistics',
          meta: {
            routeArr: [
              { name: '券管理', Rpath: '/home/coupons' },
              { name: '统计', Rpath: '/home/coupons-statistics' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'coupons-detail',
          component: couponsDetail,
          name: 'couponsDetail',
          meta: {
            routeArr: [
              { name: '券管理', Rpath: '/home/coupons' },
              { name: '查看详情', Rpath: '/home/coupons-detail' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'coupons-approve',
          component: couponsApprove,
          name: 'couponsApprove',
          meta: {
            routeArr: [
              { name: '券审核', Rpath: '/home/coupons-approve' },
              { name: '券审核', Rpath: '/home/coupons-approve' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'activitys-question',
          component: activitysQuestion,
          name: 'activitysQuestion',
          meta: {
            routeArr: [
              { name: '营销活动', Rpath: '/home/activity' },
              { name: '题库管理', Rpath: '/home/activitys-question' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'add-activitys',
          component: addActivitys,
          name: 'addActivitys',
          meta: {
            routeArr: [
              { name: '活动管理', Rpath: '/home/activity' },
              { name: '添加活动', Rpath: '/home/add-activitys' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'edit-activitys',
          component: editActivitys,
          name: 'editActivitys',
          meta: {
            routeArr: [
              { name: '活动管理', Rpath: '/home/activity' },
              { name: '编辑活动', Rpath: '/home/edit-activitys' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'look-activitys',
          component: lookActivitys,
          name: 'lookActivitys',
          meta: {
            routeArr: [
              { name: '营销活动', Rpath: '/home/activity' },
              { name: '查看活动', Rpath: '/home/look-activitys' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'activitys-statistics',
          component: activitysStatistics,
          name: 'activitysStatistics',
          meta: {
            routeArr: [
              { name: '布奖活动管理', Rpath: '/home/activity?t=1' },
              { name: '活动统计', Rpath: '/home/activitys-statistics' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'add-activity',
          component: addActivity,
          name: 'addActivity',
          meta: {
            routeArr: [
              { name: '活动管理', Rpath: '/home/activity-list' },
              { name: '活动设置', Rpath: '/home/add-activity' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'activity-details',
          component: activityDetails,
          name: 'activityDetails',
          meta: {
            routeArr: [
              { name: '活动管理', Rpath: '/home/activity-list' },
              { name: '活动详情', Rpath: '/home/activity-details' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'edit-activity',
          component: editActivity,
          name: 'editActivity',
          meta: {
            routeArr: [
              { name: '活动管理', Rpath: '/home/activity-list' },
              { name: '编辑活动', Rpath: '/home/edit-activity' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'activity-statistics',
          component: activityStatistics,
          name: 'activityStatistics',
          meta: {
            routeArr: [
              { name: '活动管理', Rpath: '/home/activity-list' },
              { name: '活动统计', Rpath: '/home/activity-statistics' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'participants-number',
          component: participantsNumber,
          name: 'participantsNumber',
          meta: {
            routeArr: [
              { name: '活动管理', Rpath: '/home/activity-list' },
              { name: '活动统计', Rpath: '/home/participants-numbers' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'activity-statistics-list',
          component: activityStatisticsList,
          name: 'activityStatisticsList',
          meta: {
            routeArr: [
              { name: '线下活动', Rpath: '/home/activity-statistics-list' },
              { name: '数据统计', Rpath: '/home/activity-statistics-list' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },

        {
          path: 'micro-page',
          component: microPage,
          name: 'microPage',
          meta: {
            routeArr: [
              { name: '微页面管理', Rpath: '/home/micro-page' },
              { name: '微页面', Rpath: '/home/micro-page' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'micro-page-add',
          component: microPageAdd,
          name: 'microPageAdd',
          meta: {
            routeArr: [
              { name: '微页面', Rpath: '/home/micro-page' },
              { name: '新建微页面', Rpath: '/home/micro-page-add' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'micro-page-edit',
          component: microPageEdit,
          name: 'microPageEdit',
          meta: {
            routeArr: [
              { name: '微页面', Rpath: '/home/micro-page' },
              { name: '编辑微页面', Rpath: '/home/micro-page-edit' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'micro-page-look',
          component: microPageLook,
          name: 'microPageLook',
          meta: {
            routeArr: [
              { name: '微页面', Rpath: '/home/micro-page' },
              { name: '微页面详情', Rpath: '/home/micro-page-look' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'micro-page-data',
          component: microPageData,
          name: 'microPageData',
          meta: {
            routeArr: [
              { name: '微页面', Rpath: '/home/micro-page' },
              { name: '微页面统计', Rpath: '/home/micro-page-data' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'sn-manage',
          component: snManage,
          name: 'snManage',
          meta: {
            routeArr: [
              { name: '活动管理', Rpath: '/home/sn-manage' },
              { name: 'SN码管理', Rpath: '/home/sn-manage' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'cheat-manage',
          component: cheatManage,
          name: 'cheatManage',
          meta: {
            routeArr: [
              { name: '活动管理', Rpath: '/home/cheat-manage' },
              { name: '作弊管理', Rpath: '/home/cheat-manage' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'integral-setting',
          component: integralSetting,
          name: 'integralSetting',
          meta: {
            routeArr: [
              { name: '积分商城', Rpath: '/home/integral-setting' },
              { name: '积分设置', Rpath: '/home/integral-setting' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'edit-advertise',
          component: editAdvertise,
          name: 'editAdvertise',
          meta: {
            routeArr: [
              { name: 'Banner', Rpath: '/home/advertise-list' },
              { name: '编辑广告', Rpath: '/home/edit-advertise' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'reply-keyWord',
          component: ReplyKeyWord,
          name: 'ReplyKeyWord',
          meta: {
            routeArr: [
              { name: '微信管理', Rpath: '/home/reply-keyWord' },
              { name: '关键词回复', Rpath: '/home/reply-keyWord' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'reply-keyWord-add',
          component: ReplyKeyWordAdd,
          name: 'ReplyKeyWordAdd',
          meta: {
            routeArr: [
              { name: '微信管理', Rpath: '/home/reply-keyWord' },
              { name: '关键词回复', Rpath: '/home/reply-keyWord' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'reply-follow',
          component: ReplyFollow,
          name: 'ReplyFollow',
          meta: {
            routeArr: [
              { name: '微信管理', Rpath: '/home/reply-follow' },
              { name: '关注回复', Rpath: '/home/reply-follow' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'reply-default',
          component: ReplyDefault,
          name: 'ReplyDefault',
          meta: {
            routeArr: [
              { name: '微信管理', Rpath: '/home/reply-default' },
              { name: '默认回复', Rpath: '/home/reply-default' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'custom-menu',
          component: customMenu,
          name: 'customMenu',
          meta: {
            routeArr: [
              { name: '微信管理', Rpath: '/home/custom-menu' },
              { name: '自定义菜单', Rpath: '/home/custom-menu' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'custom-menu-add',
          component: customMenuAdd,
          name: 'customMenuAdd',
          meta: {
            routeArr: [
              { name: '微信管理', Rpath: '/home/custom-menu' },
              { name: '自定义菜单', Rpath: '/home/custom-menu-add' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'artificial-service',
          component: artificialService,
          name: 'artificialService',
          meta: {
            routeArr: [
              { name: '微信管理', Rpath: '/home/artificial-service' },
              { name: '人工客服', Rpath: '/home/artificial-service' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'artificial-service-add',
          component: artificialServiceAdd,
          name: 'artificialServiceAdd',
          meta: {
            routeArr: [
              { name: '微信管理', Rpath: '/home/artificial-service' },
              { name: '人工客服', Rpath: '/home/artificial-service-add' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'template-message',
          component: templateMessage,
          name: 'templateMessage',
          meta: {
            routeArr: [
              { name: '微信管理', Rpath: '/home/template-message' },
              { name: '模板消息', Rpath: '/home/template-message' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'template-message-add',
          component: templateMessageAdd,
          name: 'templateMessageAdd',
          meta: {
            routeArr: [
              { name: '微信管理', Rpath: '/home/template-message' },
              { name: '模板消息', Rpath: '/home/template-message' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'wx-payment',
          component: wxPayment,
          name: 'wxPayment',
          meta: {
            routeArr: [
              { name: '微信管理', Rpath: '/home/wx-payment' },
              { name: '微信支付', Rpath: '/home/wx-payment' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'wx-payment-add',
          component: wxPaymentAdd,
          name: 'wxPaymentAdd',
          meta: {
            routeArr: [
              { name: '微信管理', Rpath: '/home/wx-payment' },
              { name: '微信支付', Rpath: '/home/wx-payment-add' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'wx-payment-edit',
          component: wxPaymentEdit,
          name: 'wxPaymentEdit',
          meta: {
            routeArr: [
              { name: '微信管理', Rpath: '/home/wx-payment' },
              { name: '编辑微信支付', Rpath: '/home/wx-payment-edit' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },

        {
          path: 'product-details',
          component: productDetails,
          name: 'productDetails',
          meta: {
            routeArr: [
              { name: '产品列表', Rpath: '/home/product-list' },
              { name: '产品详情', Rpath: '/home/product-details' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'edit-product',
          component: editProduct,
          name: 'editProduct',
          meta: {
            routeArr: [
              { name: '产品列表', Rpath: '/home/product-list' },
              { name: '编辑产品', Rpath: '/home/edit-product' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'add-product',
          component: addProduct,
          name: 'addProduct',
          meta: {
            routeArr: [
              { name: '产品列表', Rpath: '/home/product-list' },
              { name: '添加产品', Rpath: '/home/add-product' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'order-list',
          component: orderList,
          name: 'orderList',
          meta: {
            routeArr: [
              { name: '积分商城', Rpath: '/home/order-list' },
              { name: '订单列表', Rpath: '/home/order-list' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'advertise-list',
          component: advertiseList,
          name: 'advertiseList',
          meta: {
            routeArr: [
              { name: '会员互动', Rpath: '/home/advertise-list' },
              { name: 'Banner', Rpath: '/home/advertise-list' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'add-advertise',
          component: addAdvertise,
          name: 'addAdvertise',
          meta: {
            routeArr: [
              { name: 'Banner', Rpath: '/home/advertise-list' },
              { name: '添加广告', Rpath: '/home/add-advertise' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'open-platform',
          component: openPlatform,
          name: 'openPlatform',
          meta: {
            routeArr: [
              { name: '微信管理', Rpath: '/home/open-platform' },
              { name: '开放平台配置', Rpath: '/home/open-platform' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'public-number',
          component: publicNumber,
          name: 'publicNumber',
          meta: {
            routeArr: [
              { name: '微信管理', Rpath: '/home/public-number' },
              { name: '公众号管理', Rpath: '/home/public-number' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'bind-public-number',
          component: bindPublicNumber,
          name: 'bindPublicNumber',
          meta: {
            routeArr: [
              { name: '微信管理', Rpath: '/home/public-number' },
              { name: '绑定模型', Rpath: '/home/bind-public-number' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'applet-manage',
          component: appletManage,
          name: 'appletManage',
          meta: {
            routeArr: [
              { name: '云众', Rpath: '/home/applet-manage' },
              { name: '小程序管理', Rpath: '/home/applet-manage' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'yzintegralset',
          component: yzIntegralSet,
          name: 'yzintegralset',
          meta: {
            routeArr: [
              { name: '积分管理', Rpath: '/home/yzintegralset' },
              { name: '积分兑换', Rpath: '/home/yzintegralset' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'yzintegralset-add',
          component: yzIntegralSetAdd,
          name: 'addYzIntegralSet',
          meta: {
            routeArr: [
              { name: '积分兑换', Rpath: '/home/yzintegralset' },
              { name: '积分兑换-添加', Rpath: '/home/yzintegralset-add' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'yzintegralset-edit',
          component: yzIntegralSetEdit,
          name: 'editYzIntegralSet',
          meta: {
            routeArr: [
              { name: '积分兑换', Rpath: '/home/yzintegralset' },
              { name: '积分兑换-添加', Rpath: '/home/yzintegralset-edit' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'yzgrade',
          component: yzGrade,
          name: 'yzgrade',
          meta: {
            routeArr: [
              { name: '积分管理', Rpath: '/home/yzgrade' },
              { name: '等级设置', Rpath: '/home/yzgrade' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'edit-member-interest',
          component: editMemberInterest,
          name: 'editMemberInterest',
          meta: {
            routeArr: [
              { name: '会员权益设置', Rpath: '/home/member-interest-setting' },
              { name: '编辑会员权益', Rpath: '/home/edit-member-interest' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'administrative/menu-list',
          component: menuList,
          name: 'menuList',
          meta: {
            routeArr: [
              { name: '菜单列表', Rpath: '/home/administrative/menu-list' },
              { name: '菜单列表', Rpath: '/home/administrative/menu-list' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'administrative/menu-add',
          component: menuAdd,
          name: 'menuAdd',
          meta: {
            routeArr: [
              { name: '菜单列表', Rpath: '/home/administrative/menu-list' },
              { name: '添加菜单', Rpath: '/home/administrative/menu-add' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'administrative/menu-edit',
          component: menuEdit,
          name: 'menuEdit',
          meta: {
            routeArr: [
              { name: '菜单列表', Rpath: '/home/administrative/menu-list' },
              { name: '编辑菜单', Rpath: '/home/administrative/menu-edit' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'administrative/config-add',
          component: configAdd,
          name: 'configAdd',
          meta: {
            routeArr: [
              { name: '系统参数', Rpath: '/home/administrative/config-add' },
              { name: '系统参数', Rpath: '/home/administrative/config-add' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'administrative/rule-list',
          component: ruleList,
          name: 'ruleList',
          meta: {
            routeArr: [
              { name: '权限规则', Rpath: '/home/administrative/rule-list' },
              { name: '权限规则', Rpath: '/home/administrative/rule-list' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'administrative/rule-add',
          component: ruleAdd,
          name: 'ruleAdd',
          meta: {
            routeArr: [
              { name: '权限规则', Rpath: '/home/administrative/rule-list' },
              { name: '权限添加', Rpath: '/home/administrative/rule-add' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'administrative/rule-edit',
          component: ruleEdit,
          name: 'ruleEdit',
          meta: {
            routeArr: [
              { name: '权限规则', Rpath: '/home/administrative/rule-list' },
              { name: '权限编辑', Rpath: '/home/administrative/rule-edit' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'administrative/structures-list',
          component: structuresList,
          name: 'structuresList',
          meta: {
            routeArr: [
              { name: '权限设置', Rpath: '/home/administrative/structures-list' },
              { name: '部门管理', Rpath: '/home/administrative/structures-list' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'administrative/structures-add',
          component: structuresAdd,
          name: 'structuresAdd',
          meta: {
            routeArr: [
              { name: '部门管理', Rpath: '/home/administrative/structures-list' },
              { name: '部门添加', Rpath: '/home/administrative/structures-add' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'administrative/structures-edit',
          component: structuresEdit,
          name: 'structuresEdit',
          meta: {
            routeArr: [
              { name: '部门管理', Rpath: '/home/administrative/structures-list' },
              { name: '部门编辑', Rpath: '/home/administrative/structures-edit' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'administrative/groups-list',
          component: groupsList,
          name: 'groupsList',
          meta: {
            routeArr: [
              { name: '用户组管理', Rpath: '/home/administrative/groups-list' },
              { name: '用户组管理', Rpath: '/home/administrative/groups-list' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'administrative/groups-add',
          component: groupsAdd,
          name: 'groupsAdd',
          meta: {
            routeArr: [
              { name: '用户组管理', Rpath: '/home/administrative/groups-list' },
              { name: '用户组添加', Rpath: '/home/administrative/groups-add' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'administrative/groups-edit',
          component: groupsEdit,
          name: 'groupsEdit',
          meta: {
            routeArr: [
              { name: '用户组管理', Rpath: '/home/administrative/groups-list' },
              { name: '用户组编辑', Rpath: '/home/administrative/groups-edit' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'administrative/position-list',
          component: positionList,
          name: 'positionList',
          meta: {
            routeArr: [
              { name: '权限设置', Rpath: '/home/administrative/position-list' },
              { name: '角色管理', Rpath: '/home/administrative/position-list' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'administrative/position-add',
          component: positionAdd,
          name: 'positionAdd',
          meta: {
            routeArr: [
              { name: '角色管理', Rpath: '/home/administrative/position-list' },
              { name: '角色添加', Rpath: '/home/administrative/position-add' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'administrative/position-rule-set',
          component: positionRuleSet,
          name: 'positionRuleSet',
          meta: {
            routeArr: [
              { name: '角色管理', Rpath: '/home/administrative/position-list' },
              { name: '权限设置', Rpath: '/home/administrative/position-rule-set' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'administrative/position-rule-setNew',
          component: positionRuleSetNew,
          name: 'positionRuleSetNew',
          meta: {
            routeArr: [
              { name: '角色管理', Rpath: '/home/administrative/position-list' },
              { name: '权限设置', Rpath: '/home/administrative/position-rule-setNew' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'administrative/position-edit',
          component: positionEdit,
          name: 'positionEdit',
          meta: {
            routeArr: [
              { name: '角色管理', Rpath: '/home/administrative/position-list' },
              { name: '角色编辑', Rpath: '/home/administrative/position-edit' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'administrative/user-list',
          component: userList,
          name: 'userList',
          meta: {
            routeArr: [
              { name: '权限设置', Rpath: '/home/administrative/user-list' },
              { name: '用户管理', Rpath: '/home/administrative/user-list' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'administrative/businessAreaList',
          component: businessAreaList,
          name: 'businessAreaList',
          meta: {
            routeArr: [
              { name: '权限设置', Rpath: '/home/administrative/user-list' },
              { name: '业务区域管理', Rpath: '/home/administrative/businessAreaList' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        // 添加编辑详情
        {
          path: 'administrative/businessAreaAddEdit',
          component: businessAreaAddEdit,
          name: 'businessAreaAddEdit',
          meta: {
            routeArr: [
              { name: '权限设置', Rpath: '/home/administrative/user-list' },
              { name: '业务区域管理', Rpath: '/home/administrative/businessAreaAddEdit' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'administrative/user-add',
          component: userAdd,
          name: 'userAdd',
          meta: {
            routeArr: [
              { name: '成员列表', Rpath: '/home/administrative/user-list' },
              { name: '成员添加', Rpath: '/home/administrative/user-add' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'administrative/user-edit',
          component: userEdit,
          name: 'userEdit',
          meta: {
            routeArr: [
              { name: '成员列表', Rpath: '/home/administrative/user-list' },
              { name: '成员编辑', Rpath: '/home/administrative/user-edit' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'salesman-list',
          component: salesmanList,
          name: 'salesmanList',
          meta: {
            routeArr: [
              { name: '线下活动', Rpath: '/home/salesman-list' },
              { name: '业务员列表', Rpath: '/home/salesman-list' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'activity-count-list',
          component: activityCountList,
          name: 'activityCountList',
          meta: {
            routeArr: [
              { name: '活动类型管理', Rpath: '/home/offline-activity-list' },
              { name: '申请记录', Rpath: '/home/activity-count-list' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'field-manage',
          component: fieldManage,
          name: 'fieldManage',
          meta: {
            routeArr: [
              { name: '线下活动', Rpath: '/home/field-manage' },
              { name: '场次管理', Rpath: '/home/field-manage' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'field-total',
          component: fieldTotal,
          name: 'fieldTotal',
          meta: {
            routeArr: [
              { name: '场次管理', Rpath: '/home/field-manage' },
              { name: '场次统计', Rpath: '/home/field-total' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'activity-count-details',
          component: activityCountDetails,
          name: 'activityCountDetails',
          meta: {
            routeArr: [
              { name: '线下活动', Rpath: '/home/offline-activity-list' },
              { name: '记录详情', Rpath: '/home/activity-count-details' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'add-offline-activity',
          component: addOfflineAcivity,
          name: 'addOfflineAcivity',
          meta: {
            routeArr: [
              { name: '线下活动', Rpath: '/home/offline-activity-list' },
              { name: '新建活动', Rpath: '/home/add-offline-activity' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'edit-offline-activity',
          component: editOfflineAcivity,
          name: 'editOfflineAcivity',
          meta: {
            routeArr: [
              { name: '线下活动', Rpath: '/home/offline-activity-list' },
              { name: '编辑活动', Rpath: '/home/edit-offline-activity' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'offline-activity-list',
          component: offlineActivityList,
          name: 'offlineActivityList',
          meta: {
            routeArr: [
              { name: '线下活动', Rpath: '/home/offline-activity-list' },
              { name: '活动类型管理', Rpath: '/home/offline-activity-list' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'offline-activity-set',
          component: offlineActivitySet,
          name: 'offlineActivitySet',
          meta: {
            routeArr: [
              { name: '线下活动', Rpath: '/home/offline-activity-set' },
              { name: '活动配置', Rpath: '/home/offline-activity-set' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'card-ticket-module',
          component: cardTicketModule,
          name: 'cardTicketModule',
          meta: {
            routeArr: [
              { name: '卡券管理', Rpath: '/home/card-ticket-module' },
              { name: '卡券模板管理', Rpath: '/home/card-ticket-module' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'card-ticket-grantDetails',
          component: cardTicketGrantDetails,
          name: 'cardTicketGrantDetails',
          meta: {
            routeArr: [
              { name: '卡券管理', Rpath: '/home/card-ticket-module' },
              { name: '发放明细', Rpath: '/home/card-ticket-grantDetails' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'card-ticket-hxoff',
          component: cardTicketHxoff,
          name: 'cardTicketHxoff',
          meta: {
            routeArr: [
              { name: '卡券管理', Rpath: '/home/card-ticket-module' },
              { name: '核销明细', Rpath: '/home/card-ticket-hxoff' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'card-ticket-new',
          component: cardTicketNew,
          name: 'cardTicketNew',
          meta: {
            routeArr: [
              { name: '卡券模板管理', Rpath: '/home/card-ticket-module' },
              { name: '新建模板', Rpath: '/home/card-ticket-new' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'card-ticket-edit',
          component: cardTicketEdit,
          name: 'cardTicketEdit',
          meta: {
            routeArr: [
              { name: '卡券模板管理', Rpath: '/home/card-ticket-module' },
              { name: '编辑模板', Rpath: '/home/card-ticket-edit' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'card-ticket-see',
          component: cardTicketSee,
          name: 'cardTicketSee',
          meta: {
            routeArr: [
              { name: '卡券模板管理', Rpath: '/home/card-ticket-module' },
              { name: '查看模板', Rpath: '/home/card-ticket-see' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'writeoff-setup',
          component: writeOffSetUp,
          name: 'cardTicketSee',
          meta: {
            routeArr: [
              { name: '卡券模板管理', Rpath: '/home/writeoff-setup' },
              { name: '核销设置', Rpath: '/home/writeoff-setup' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'offline-acitivity-statistics',
          component: offlineActivityStatistics,
          name: 'offlineActivityStatistics',
          meta: {
            routeArr: [
              { name: '场次管理', Rpath: '/home/field-manage' },
              { name: '活动统计', Rpath: '/home/offline-acitivity-statistics' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'inspiration-not-finish',
          component: inspirationNotFinish,
          name: 'inspirationNotFinish',
          meta: {
            routeArr: [
              // { name: '灵感', Rpath: '/home/inspiration-not-finish' },
              // { name: '灵感', Rpath: '/home/inspiration-not-finish' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'customer-analyse',
          component: customerAnalyse,
          name: 'customerAnalyse',
          meta: {
            routeArr: [
              { name: '分析中心', Rpath: '/home/customer-analyse' },
              { name: '受众分析', Rpath: '/home/customer-analyse' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'behavior-analyse',
          component: behaviorAnalyse,
          name: 'behaviorAnalyse',
          meta: {
            routeArr: [
              { name: '分析中心', Rpath: '/home/behavior-analyse' },
              { name: '行为分析', Rpath: '/home/behavior-analyse' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'funnel-analyse',
          component: funnelAnalyse,
          name: 'funnelAnalyse',
          meta: {
            routeArr: [
              { name: '分析', Rpath: '/home/funnel-analyse' },
              { name: '漏斗分析', Rpath: '/home/funnel-analyse' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'order-analyse',
          component: orderAnalyse,
          name: 'orderAnalyse',
          meta: {
            routeArr: [
              { name: '分析', Rpath: '/home/order-analyse' },
              { name: '订单分析', Rpath: '/home/order-analyse' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'repurchase-analyse',
          component: repurchaseAnalyse,
          name: 'repurchaseAnalyse',
          meta: {
            routeArr: [
              { name: '分析', Rpath: '/home/repurchase-analyse' },
              { name: '复购分析', Rpath: '/home/repurchase-analyse' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'rfm-analyse',
          component: rfmAnalyse,
          name: 'rfmAnalyse',
          meta: {
            routeArr: [
              { name: '分析', Rpath: '/home/rfm-analyse' },
              { name: 'RFM分析', Rpath: '/home/rfm-analyse' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'single-chart',
          component: singleChart,
          name: 'singleChart',
          meta: {
            routeArr: [
              { name: '单图', Rpath: '/home/single-chart' },
              { name: '单图', Rpath: '/home/single-chart' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'board-details',
          component: boardDetails,
          name: 'boardDetails',
          meta: {
            routeArr: [
              { name: '看板列表', Rpath: '/home/board-list' },
              { name: '看板详情', Rpath: '/home/board-details' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'board-list',
          component: boardStatistics,
          name: 'boardStatistics',
          meta: {
            routeArr: [
              { name: '看板', Rpath: '/home/board-list' },
              { name: '看板', Rpath: '/home/board-list' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'add-single-chart',
          component: addSingleChart,
          name: 'addSingleChart',
          meta: {
            routeArr: [
              { name: '看板列表', Rpath: '/home/board-list' },
              { name: '单图列表', Rpath: '/home/add-single-chart' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        // 视频管理
        {
          path: 'activityVideoManager',
          component: activityVideoManager,
          name: 'activityVideoManager',
          meta: {
            routeArr: [
              { name: '活动管理', Rpath: '/home/activityVideoManager' },
              { name: '活动管理', Rpath: '/home/activityVideoManager' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'videoListManager',
          component: videoListManager,
          name: 'videoListManager',
          meta: {
            routeArr: [
              { name: '视频管理', Rpath: '/home/videoListManager' },
              { name: '视频管理', Rpath: '/home/videoListManager' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },

      ]
    },
    // 景芝猜灯谜活动
    {
      path: '/home',
      name: 'Home',
      component: Home,
      children: [
        {
          path: 'guess-riddles-activity',
          component: guessRiddlesActivity,
          name: 'guessRiddlesActivity',
          meta: {
            routeArr: [
              { name: '活动管理', Rpath: '/home/guess-riddles-activity' },
              { name: '猜灯谜活动', Rpath: '/home/guess-riddles-activity' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'add-guess-riddles-activity',
          component: addGuessRiddlesActivity,
          name: 'addGuessRiddlesActivity',
          meta: {
            routeArr: [
              { name: '活动管理', Rpath: '/home/guess-riddles-activity' },
              { name: '添加猜灯谜活动', Rpath: '/home/add-guess-riddles-activity' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'edit-guess-riddles-activity',
          component: editGuessRiddlesActivity,
          name: 'editGuessRiddlesActivity',
          meta: {
            routeArr: [
              { name: '活动管理', Rpath: '/home/guess-riddles-activity' },
              { name: '编辑猜灯谜活动', Rpath: '/home/edit-guess-riddles-activity' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'look-guess-riddles-activity',
          component: lookGuessRiddlesActivity,
          name: 'lookGuessRiddlesActivity',
          meta: {
            routeArr: [
              { name: '活动管理', Rpath: '/home/guess-riddles-activity' },
              { name: '查看猜灯谜活动', Rpath: '/home/look-guess-riddles-activity' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'guess-riddles-activity-statistics',
          component: guessRiddlesActivityStatistics,
          name: 'guessRiddlesActivityStatistics',
          meta: {
            routeArr: [
              { name: '活动管理', Rpath: '/home/guess-riddles-activity' },
              { name: '猜灯谜活动统计', Rpath: '/home/guess-riddles-activity-statistics' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        // 题库
        {
          path: 'guess-riddles-topic',
          component: guessRiddlesTopic,
          name: 'guessRiddlesTopic',
          meta: {
            routeArr: [
              { name: '活动管理', Rpath: '/home/guess-riddles-activity' },
              { name: '猜灯谜题库管理', Rpath: '/home/guess-riddles-topic' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'model-consumer',
          component: modelConsumer,
          name: 'modelConsumer',
          meta: {
            routeArr: [
              { name: '客户管理', Rpath: '/home/customer-manage' },
              { name: '终端店详情', Rpath: '/home/model-consumer' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'model-business',
          component: modelBusiness,
          name: 'modelBusiness',
          meta: {
            routeArr: [
              { name: '客户管理', Rpath: '/home/customer-manage' },
              { name: '终端店详情', Rpath: '/home/model-business' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'prize-list',
          component: prizeList,
          name: 'prizeList',
          meta: {
            routeArr: [
              { name: '布奖管理', Rpath: '/home/prize-list' },
              { name: '创建布奖', Rpath: '/home/prize-list' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'create-prize',
          component: createPrize,
          name: 'createPrize',
          meta: {
            routeArr: [
              { name: '布奖管理', Rpath: '/home/prize-list' },
              { name: '创建布奖', Rpath: '/home/create-prize' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'edit-prize',
          component: editPrize,
          name: 'editPrize',
          meta: {
            routeArr: [
              { name: '布奖管理', Rpath: '/home/prize-list' },
              { name: '编辑布奖', Rpath: '/home/edit-prize' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'template-prize',
          component: templatePrize,
          name: 'templatePrize',
          meta: {
            routeArr: [
              { name: '布奖管理', Rpath: '/home/template-prize' },
              { name: '创建布奖', Rpath: '/home/template-prize' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'prize-activity',
          component: prizeActivity,
          name: 'prizeActivity',
          meta: {
            routeArr: [
              { name: '布奖管理', Rpath: '/home/prize-list' },
              { name: '创建布奖', Rpath: '/home/prize-activity' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'prize-statistics',
          component: prizeStatistics,
          name: 'prizeStatistics',
          meta: {
            routeArr: [
              { name: '布奖管理', Rpath: '/home/prize-list' },
              { name: '创建布奖', Rpath: '/home/prize-statistics' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'set-prize-activity',
          component: setPrizeActivity,
          name: 'setPrizeActivity',
          meta: {
            routeArr: [
              { name: '活动管理', Rpath: '/home/prize-list' },
              { name: '创建活动', Rpath: '/home/set-prize-activity' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'my-template-prize',
          component: myTemplatePrize,
          name: 'myTemplatePrize',
          meta: {
            routeArr: [
              { name: '活动管理', Rpath: '/home/prize-list' },
              { name: '模板管理', Rpath: '/home/my-template-prize' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'edit-prize-activity',
          component: editPrizeActivity,
          name: 'editPrizeActivity',
          meta: {
            routeArr: [
              { name: '活动管理', Rpath: '/home/prize-list' },
              { name: '编辑活动', Rpath: '/home/edit-prize-activity' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'template-details',
          component: templateDetails,
          name: 'templateDetails',
          meta: {
            routeArr: [
              { name: '活动管理', Rpath: '/home/prize-list' },
              { name: '模板详情', Rpath: '/home/template-details' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        }
      ]
    },
    // 云销
    {
      path: '/home',
      name: 'Home',
      component: Home,
      children: [
        {
          path: 'yxwelcome',
          component: yxwelcome,
          name: 'yxwelcome',
          meta: {
            routeArr: [
              { name: '云商管理', Rpath: '/home/yxwelcome' },
              { name: '欢迎页', Rpath: '/home/yxwelcome' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'yxdealer',
          component: yxdealer,
          name: 'yxdealer',
          meta: {
            routeArr: [
              { name: '云商管理', Rpath: '/home/yxwelcome' },
              { name: '经销商管理', Rpath: '/home/yxdealer' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'yxdealersub',
          component: yxdealersub,
          name: 'yxdealersub',
          meta: {
            routeArr: [
              { name: '经销商管理', Rpath: '/home/yxdealer' },
              { name: '经销商管理', Rpath: '/home/yxdealersub' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'yxrules',
          component: yxrules,
          name: 'yxrules',
          meta: {
            routeArr: [
              { name: '角色管理', Rpath: '/home/yxgroup' },
              { name: '权限设置', Rpath: '/home/yxrules' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'yxaccount',
          component: yxaccount,
          name: 'yxaccount',
          meta: {
            routeArr: [
              { name: '云商管理', Rpath: '/home/yxwelcome' },
              { name: '开票管理', Rpath: '/home/yxaccount' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'yxaccount_tx',
          component: yxaccount_tx,
          name: 'yxaccount_tx',
          meta: {
            routeArr: [
              { name: '云商管理', Rpath: '/home/yxwelcome' },
              { name: '提现管理', Rpath: '/home/yxaccount_tx' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'yxmarketing',
          component: yxmarketing,
          name: 'yxmarketing',
          meta: {
            routeArr: [
              { name: '云商管理', Rpath: '/home/yxwelcome' },
              { name: '活动管理', Rpath: '/home/yxmarketing' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'add-yxmarketing',
          component: yxmarketingAdd,
          name: 'yxmarketingadd',
          meta: {
            routeArr: [
              { name: '活动管理', Rpath: '/home/yxmarketing' },
              { name: '添加活动', Rpath: '/home/add-yxmarketing' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'edit-yxmarketing',
          component: yxmarketingEdit,
          name: 'yxmarketingedit',
          meta: {
            routeArr: [
              { name: '活动管理', Rpath: '/home/yxmarketing' },
              { name: '编辑活动', Rpath: '/home/edit-yxmarketing' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'yxbank',
          component: yxbank,
          name: 'yxbank',
          meta: {
            routeArr: [
              { name: '云商管理', Rpath: '/home/yxwelcome' },
              { name: '银行管理', Rpath: '/home/yxbank' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'yxgroup',
          component: yxgroup,
          name: 'yxgroup',
          meta: {
            routeArr: [
              { name: '云商管理', Rpath: '/home/yxwelcome' },
              { name: '角色管理', Rpath: '/home/yxgroup' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'yxqa',
          component: yxqa,
          name: 'yxqa',
          meta: {
            routeArr: [
              { name: '云商管理', Rpath: '/home/yxwelcome' },
              { name: '帮助中心', Rpath: '/home/yxqa' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
        {
          path: 'yxoperatelog',
          component: yxoperatelog,
          name: 'yxoperatelog',
          meta: {
            routeArr: [
              { name: '云商管理', Rpath: '/home/yxwelcome' },
              { name: '操作日志', Rpath: '/home/yxoperatelog' }
            ],
            hideLeft: false,
            module: '',
            menu: ''
          }
        },
      ]
    },
    {
      path: '/login',
      component: login,
      name: 'login'
    }
  ]
})
export default router
